module.exports = __webpack_public_path__ + "static/media/Windmolen.343ef1e9.mp3";